import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { getAction, httpAction } from '@/api/manage';
import SelectAssetChemicalModal from "../../../assets/SelectAssetChemicalModal";
import IwsUpload from '@comp/upload/IwsUpload';
import pick from 'lodash.pick';
import moment from 'moment';
import { queryUserTreeList } from '@/api/api';
export default {
  name: 'ChemicalLossModal',
  mixins: [ModalFormMixin, GetSiteIdMixin],
  components: {
    SelectAssetChemicalModal: SelectAssetChemicalModal,
    IwsUpload: IwsUpload
  },
  data: function data() {
    return {
      title: '化学品损耗表单',
      tableName: 'om_chemical_loss',
      form_fields: ['siteId', 'assetId', 'lossType', 'lossDose', 'userId', 'remark'],
      form_fields_time: ['lossDate'],
      validatorRules: {
        assetId: {
          rules: [{
            required: true,
            message: '请输入化学品资产ID!'
          }]
        },
        lossDose: {
          rules: [{
            required: true,
            message: '请输入损耗剂量!'
          }]
        }
      },
      url: {
        queryCompany: '/ea/company/info/queryCompanyName'
      },
      siteName: '',
      userTree: [],
      //人员信息
      selectedAsset: [],
      assetIds: [],
      loginUser: '',
      surplus: '',
      compareStatus: true
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.loginUser = this.$store.getters.userInfo.id;
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      this.siteId = value;
    }
  },
  methods: {
    moment: moment,
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.selectedAsset = [];
      this.assetIds = [];
      this.compareStatus = true;
      this.surplus = null;

      if (this.model.id) {
        this.assetIds = this.model.assetId ? this.model.assetId : null;
        this.model.productName = this.model.productName ? this.model.productName : null;
        this.selectedAsset.push(this.model.productName);
      } else {
        this.model.userId = this.loginUser;
        this.model.lossDate = moment(new Date(), 'YYYY-MM-DD HH:mm:ss');
      }

      this.loadTreeList();
      this.$nextTick(function () {
        var that = _this;
        that.form.setFieldsValue(pick(that.model, that.form_fields)); //时间格式化

        var timeVal = {};
        that.form_fields_time.forEach(function (item, index) {
          timeVal[item] = that.model[item] ? moment(that.model[item], 'YYYY-MM-DD HH:mm:ss') : null;
        });
        that.form.setFieldsValue(timeVal);

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData.lossDate = formData.lossDate ? formData.lossDate.format('YYYY-MM-DD HH:mm:ss') : null;
          formData.assetId = that.assetIds == [] ? null : that.assetIds;
          formData.siteId = _this2.siteId;
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    loadCompany: function loadCompany() {
      var that = this;
      that.companyList = [];
      getAction(this.url.queryCompany).then(function (res) {
        if (res.success) {
          that.companyList = res.result;
        }
      });
    },
    //加载人员信息
    loadTreeList: function loadTreeList() {
      var that = this;
      that.userTree = []; // 用户

      queryUserTreeList().then(function (res) {
        if (res.success) {
          that.userTree = res.result;
        }
      });
    },
    selectAssets: function selectAssets() {
      this.$refs.AssetChemicalModal.siteId = this.siteId;
      this.$refs.AssetChemicalModal.disableSubmit = true;
      this.$refs.AssetChemicalModal.add(this.selectedAsset, this.assetIds);
    },
    // 子modal回调
    choseProduct: function choseProduct(productList) {
      this.selectedAsset = [];
      this.assetIds = [];

      for (var i = 0; i < productList.length; i++) {
        this.selectedAsset.push(productList[i].productName);
        this.assetIds = productList[i].id;
        this.surplus = productList[i].surplus;
      }

      this.total();
    },
    total: function total() {
      if (this.surplus != null) {
        if (this.form.getFieldValue('lossDose') == 0 || this.surplus < this.form.getFieldValue('lossDose')) {
          this.compareStatus = false;
          this.$message.error('化学品存量不足,请选择其他化学品!');
        } else {
          this.compareStatus = true;
        }
      }
    }
  }
};